import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"mt-10 mb-6\"><ul class=\"flex gap-10 text-gray-600 text-base leading-[36px]\"><li class=\"text-black t-16r leading-10 font-medium border-wrh-blue-light border-b-3 cursor-pointer\">Update My Contact Info</li><li class=\"border-b-3 border-transparent t-16r leading-10 cursor-pointer\">Change My Password</li><li class=\"border-b-3 border-transparent t-16r leading-10 cursor-pointer\">Add Additional User</li><li class=\"border-b-3 border-transparent t-16r leading-10 cursor-pointer\">Transfer Warranty</li></ul></div>", 1)
const _hoisted_2 = { class: "w-full bg-white rounded-xl p-16 shadow" }

import ContactInfo from './components/ContactInfo.vue';
import AdditionalUser from './components/AdditionalUser.vue';
import ChangePassword from './components/ChangePassword.vue';
import TransferWarranty from './components/TransferWarranty.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ContactInfo),
      _createVNode(AdditionalUser),
      _createVNode(ChangePassword),
      _createVNode(TransferWarranty)
    ])
  ], 64))
}
}

})